import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import {
  InputGroup,
  DatePicker,
  InputGroupAddon,
  InputGroupText
} from "shards-react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from "@mui/material";
import "../../assets/range-date-picker.css";
import { Container, Row, Col } from "shards-react";
import UsersOverview from "../blog/UsersOverview";
import UsersByDevice from "../blog/UsersByDevice";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PhGraph from "../blog/PhGraph"

import ConductivityGraph from "../blog/Conductivity";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const RangeDatePicker = ({ className }) => {
 const currentDate = new Date();
  const oneWeekBefore = new Date();
  oneWeekBefore.setDate(currentDate.getDate() - 7);

  const [startDate, setStartDate] = React.useState(oneWeekBefore);
  const [endDate, setEndDate] = React.useState(currentDate);

  const handleStartDateChange = (value) => {
    setStartDate(new Date(value));
  };

  const handleEndDateChange = (value) => {
    setEndDate(new Date(value));
  };


    const classes = classNames(className, "d-flex", "my-auto", "date-range");
    const [openReportDialog, setOpenReportDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [token, setToken] = useState("");
      const [pdfLoading, setPdfLoading] = useState(false);
      const [data, setData] = useState([]);
      const [loading, setLoading] = useState(false);

     const handleDownloadReportPDF = () => exportElementToPdf("pdf-report", "soil-test-report");
const buildCurrentReportData = () => {
  return {
    id: "NA",
    user_id: "NA",
    test_start_time: startDate,
    soil_type: "Live Sensor Data",
    depth_cm: "-",
    latitude: "-",
    longitude: "-",
    image_url: null,

    probe_placed: true,
    placement_validated: true,
    test_confirmed: true,
    timer_started_at: startDate,
    timer_completed_at: endDate,

    n: data && data.n ? data.n : "-",
    p: data && data.p ? data.p : "-",
    k: data && data.k ? data.k : "-",
    moisture_percent: data && data.moisture ? data.moisture : "-",
    temperature_c: data && data.temperature ? data.temperature : "-",
    electrical_conductivity: data && data.conductivity ? data.conductivity : "-",
    ph: data && data.ph ? data.ph : "-",

    remarks: "Generated from date range",
    test_status: "Completed"
  };
};



     // Keep report static ordering (like your original pdf)
      const REPORT_SECTIONS = useMemo(
        () => [
          {
            fields: [
              "id",
              "user_id",
              "test_start_time",
              "soil_type",
              "depth_cm",
              "latitude",
              "longitude",
              "image_url"
            ]
          },
          {
            fields: [
              "probe_placed",
              "placement_validated",
              "test_confirmed",
              "timer_started_at",
              "timer_completed_at",
              "n",
              "p",
              "k",
              "moisture_percent",
              "temperature_c",
              "electrical_conductivity",
              "ph",
              "remarks",
              "test_status"
            ]
          }
        ],
        []
      );
      // ====== Old Report labels + lab blanks ======
  const FIELD_LABELS = {
    id: "Test ID",
    user_id: "user id",
    test_start_time: "Test Start Time",
    soil_type: "Soil Type",
    depth_cm: "Depth (inch)",
    latitude: "Latitude",
    longitude: "Longitude",
    image_url: "Image URL",
    probe_placed: "Probe Placed",
    placement_validated: "Placement Validated",
    test_confirmed: "Test Confirmed",
    timer_started_at: "Timer Started At",
    timer_completed_at: "Timer Completed At",
    n: "Nitrogen (mg/kg)",
    p: "Phosphorus (mg/kg)",
    k: "Potassium (mg/kg)",
    moisture_percent: "Moisture (%RH)",
    temperature_c: "Temperature (°C)",
    electrical_conductivity: "Conductivity (µs/cm)",
    ph: "pH",
    remarks: "Remarks",
    test_status: "Test Status"
  };
  const renderReportValue = (key, value) => {
    if (key === "image_url") {
      if (!value) return "-";
      if (!token) return "Loading image...";
      return (
        <div style={{ width: "14.4375rem", height: "7.8125rem" }}>
          <img
            src={value + "?" + token}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
      );
    }

    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (key.toLowerCase().includes("time")) return formatToIST(value);
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
  };
  const formatToIST = (utcString) => {
    if (!utcString) return "-";
    const date = new Date(utcString);
    const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
    return istDate.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
      hour12: true
    });
  };
   const LAB_FIELDS = [
    "Nitrogen (Lab Value)",
    "Phosphorus (Lab Value)",
    "Potassium (Lab Value)",
    "Moisture (Lab Value)",
    "Temperature (Lab Value)",
    "Conductivity (Lab Value)",
    "pH (Lab Value)",
    "Humidity (Lab Value)"
    // "Lab Analyst Name",
    // "Signature",
    // "Remarks (Lab)",
    // "Other Soil Nutrients"
  ];
  const exportElementToPdf = async (elementId, filePrefix) => {
    try {
      setPdfLoading(true);

      var input = document.getElementById(elementId);
      if (!input) {
        console.error(elementId + " not found");
        return;
      }

      await waitForImagesWithTimeout(input, 2000);

      var canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#fff",
        scrollX: 0,
        scrollY: -window.scrollY
      });

      var imgData = canvas.toDataURL("image/png");
      var pdf = new jsPDF("p", "mm", "a4");

      var pdfWidth = pdf.internal.pageSize.getWidth();
      var pdfHeight = pdf.internal.pageSize.getHeight();

      var imgWidth = pdfWidth;
      var imgHeight = (canvas.height * pdfWidth) / canvas.width;

      var heightLeft = imgHeight;
      var position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      var pageCount = pdf.getNumberOfPages();
      for (var i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.text("Page " + i + " of " + pageCount, pdfWidth - 30, pdfHeight - 10);
      }

      var now = new Date();
      var timestamp = now.toLocaleString("en-GB").replace(/[/,:\s]/g, "-");
      var testId =
        selectedRow && selectedRow.id !== undefined && selectedRow.id !== null
          ? selectedRow.id
          : "NA";

      var fileName = filePrefix + "-" + testId + "-" + timestamp + ".pdf";
      pdf.save(fileName);
    } catch (e) {
      console.error("PDF generation failed:", e);
    } finally {
      setPdfLoading(false);
    }
  };
   // ====== PDF helpers ======
  const waitForImagesWithTimeout = (container, timeoutMs) => {
    var imgs = container ? Array.from(container.querySelectorAll("img")) : [];
    var promises = imgs.map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = function () { resolve(); };
        img.onerror = function () { resolve(); };
      });
    });

    var timeout = new Promise((resolve) => {
      setTimeout(function () { resolve(); }, timeoutMs);
    });

    return Promise.race([Promise.all(promises), timeout]);
  };
  // Open Report
 const handleViewReport = () => {
  const reportData = buildCurrentReportData();
  setSelectedRow(reportData);
  setOpenReportDialog(true);
};

     

    return (
      <>
        <div>
          <InputGroup
            className={classes}
            style={{ display: "flex", alignItems: "center" }}
          >
            <DatePicker
              size="sm"
              selected={startDate}
              onChange={handleStartDateChange}
              placeholderText="Start Date"
              dropdownMode="select"
              className="text-center"
            />
            <DatePicker
              size="sm"
              selected={endDate}
              onChange={handleEndDateChange}
              placeholderText="End Date"
              dropdownMode="select"
              className="text-center"
            />

            <InputGroupAddon type="append">
              <InputGroupText>
                <i className="material-icons">&#xE916;</i>
              </InputGroupText>
            </InputGroupAddon>

            <Box sx={{ ml: "auto" }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleViewReport}
              >
                View Health Report
              </Button>
            </Box>
          </InputGroup>
          <br />
          <Row>
            <Col lg="12" md="12" sm="12" className="mb-4">
              <UsersOverview
                startDate={startDate}
                endDate={endDate}
              />
            </Col>
            <Col lg="12" md="6" sm="12" className="mb-4">
              <UsersByDevice
                startDate={startDate}
                endDate={endDate}
              />
            </Col>
          </Row>
        </div>
        <Dialog
          open={openReportDialog}
          onClose={() => setOpenReportDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ pb: 0 }} />
          <DialogContent>
            <Box
              id="pdf-report"
              sx={{
                padding: 3,
                backgroundColor: "#fff",
                fontFamily: "Arial, sans-serif",
                border: "1px solid #ddd",
                borderRadius: 2
              }}
            >
              <Box display="flex" justifyContent="space-between" mb={3}>
                <img src="/Agrim.png" alt="AgriM" style={{ height: 50 }} />
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  align="center"
                  flexGrow={1}
                >
                  Soil Testing Report
                </Typography>
                <Box sx={{ width: 50 }} />
              </Box>

              {selectedRow &&
  REPORT_SECTIONS.map((section, idx) => (
    <Box key={idx} sx={{ mb: 2 }}>
      {section.fields.map((key) => (
        <Box
          key={key}
          display="flex"
          justifyContent="space-between"
          mb={1}
          sx={{
            borderBottom: "1px dashed #ccc",
            paddingBottom: "4px"
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>
            {FIELD_LABELS[key] || key.replace(/_/g, " ")}
          </Typography>

          <Typography sx={{ textAlign: "right", maxWidth: "55%" }}>
            {renderReportValue(
              key,
              selectedRow && selectedRow[key]
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  ))}

              {/* <Typography mt={4} fontWeight="bold" fontSize={16}>
                Lab Test Fields:
              </Typography>
              {LAB_FIELDS.map((label, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  mb={1}
                  sx={{
                    borderBottom: "1px dashed #ccc",
                    paddingBottom: "4px"
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
                  <Typography>__________________</Typography>
                </Box>
              ))} */}
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleDownloadReportPDF}
              variant="contained"
              color="success"
              disabled={pdfLoading}
            >
              {pdfLoading ? "Generating PDF..." : "Download Report PDF"}
            </Button>
            <Button
              onClick={() => setOpenReportDialog(false)}
              variant="outlined"
              disabled={pdfLoading}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }


export default RangeDatePicker;
